import { useQuery } from "@apollo/client";

import { GqlClientUserGetAllUsersParams } from "~/__generated__";
import useCacheFilterOptions from "~/modules/app/hooks/useCacheFilterOptions";

import { ClientUserGetAllWithAccessToClientDocument } from "../queries.generated";

export default function useClientUserGetAllWithAccessToClient(params: GqlClientUserGetAllUsersParams) {
    const { data, loading, error } = useQuery(ClientUserGetAllWithAccessToClientDocument, {
        variables: {
            params: params,
        },
        errorPolicy: "all",
    });

    const queryInfo = data?.clientUserGetAllWithAccessToClient?.queryInfo;
    const [_, total] = useCacheFilterOptions(null, queryInfo?.paginationOption.total);
    return {
        loading,
        error,
        totalRows: total,
        sortableColumns: queryInfo?.sortableColumns,
        data: data?.clientUserGetAllWithAccessToClient?.data,
    };
}
